(function () {

    'use strict';

    angular.module('iplusjs.validator.trigger', [])
        .directive('iplusjsValidatorTrigger', validatorTrigger);

    validatorTrigger.$inject = [];
    function validatorTrigger() {
        return {
            restrict: 'A',
            require: ['ngModel', '^form'],
            link: function ($scope, $elem, $attrs, ctrls) {
                var fieldNames = $scope.$eval($attrs.iplusjsValidatorTrigger) || [],
                    ngModelCtrl = ctrls[0],
                    formCtrl = ctrls[1];

                if (!ngModelCtrl || !formCtrl || !fieldNames.length) {
                    return;
                }

                ngModelCtrl.$viewChangeListeners.push(function () {
                    fieldNames.forEach(function (fieldName) {
                        if (formCtrl[fieldName] && angular.isFunction(formCtrl[fieldName].$validate)) {
                            formCtrl[fieldName].$validate();
                        }
                    });
                });
            }
        };
    }
})();
